"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class BlockController {
    constructor() {
        this.plots = [];
        this.itemsPerPageClient = 5;
        this.itemsPerPageServer = 50;
        this.currentPage = 1;
        this.loader = false;
        this.plotsFilter = [];
    }
    getPlots() {
        return this.plots;
    }
    filterPlots(textSearch) {
        const plotsFilter = this.plots;
        if (textSearch.length > 0) {
            this.plotsFilter = plotsFilter.filter((plot) => {
                return (plot.client_id
                    .toString()
                    .toLowerCase()
                    .includes(textSearch.trim().toLowerCase()) ||
                    plot.user_name
                        .toString()
                        .toLowerCase()
                        .includes(textSearch.trim().toLowerCase()));
            });
        }
        else {
            this.plotsFilter = this.plots;
            return this.plots;
        }
    }
    getPlotsLength() {
        return this.plots.length;
    }
    fetchAll(plots) {
        try {
            this.plots = plots;
        }
        catch (error) {
            console.log(error);
        }
    }
    // pagination
    plotsPaginated() {
        if (this.numPages > 1) {
            const areas = [];
            let areasPagination = [];
            this.plotsFilter.forEach((element) => {
                areas.push(element);
            });
            if (this.currentPage === 1) {
                areasPagination = areas.slice(0, this.itemsPerPageClient);
            }
            else {
                areasPagination = areas.slice(this.currentPage * this.itemsPerPageClient - this.itemsPerPageClient, this.currentPage * this.itemsPerPageClient);
            }
            return areasPagination;
        }
        else {
            return this.plotsFilter;
        }
    }
    setCurrentPage(page) {
        this.loader = true;
        this.currentPage = page;
        setTimeout(() => {
            this.loader = false;
        }, 2000);
    }
    get numPages() {
        return Math.ceil(this.plotsFilter.length / this.itemsPerPageClient);
    }
    get pagesClient() {
        return this.itemsPerPageClient;
    }
    get pagesServer() {
        return this.itemsPerPageServer;
    }
    changePagesServer(newValue) {
        this.itemsPerPageServer = newValue;
    }
}
exports.default = BlockController;
